import React, { useState } from 'react';
import Tag from './Tag';
import ManageModal from './ManageModal'; // Import the ManageModal component
import GenerateReportModal from './GenerateReportModal'; // Import the GenerateReportModal component
import { FaEnvelope, FaCog, FaCheck, FaTimes, FaEye, FaFileAlt } from 'react-icons/fa'; // Added FaFileAlt for report icon

const OrganizerItem = ({ name, status }) => {
    const [acceptClicked, setAcceptClicked] = useState(false);
    const [rejectClicked, setRejectClicked] = useState(false);
    const [isManageModalOpen, setIsManageModalOpen] = useState(false); // State for the Manage Modal
    const [isGenerateReportModalOpen, setIsGenerateReportModalOpen] = useState(false); // State for the Generate Report Modal

    const itemStyle = {
        display: 'flex',
        flexDirection: 'column', // Stack content
        marginBottom: '15px',
        padding: '20px',
        border: '1px solid rgba(0, 0, 0, .125)',  // Explicit border
        borderRadius: '5px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        position: 'relative',
    };

    const contentWrapperStyle = {
        display: 'flex',
        justifyContent: 'space-between', // Keep buttons and title/tag aligned properly
        alignItems: 'center',
        width: '100%',
    };

    const contentStyle = {
        display: 'flex',
        flexDirection: 'column', // Stack title and tag vertically
    };

    const actionsStyle = {
        display: 'flex',
        justifyContent: 'flex-end',
        minWidth: '250px',
    };

    const confirmStyle = {
        width: '100%',
        marginTop: '10px',
        padding: '15px',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
        border: '2px solid',
        display: 'flex',
        flexDirection: 'column', // Stack text and buttons vertically
        alignItems: 'center',    // Center content horizontally
        justifyContent: 'center', // Center content vertically
        textAlign: 'center',      // Center text
    };

    const acceptConfirmStyle = {
        ...confirmStyle,
        borderColor: 'green',
    };

    const rejectConfirmStyle = {
        ...confirmStyle,
        borderColor: 'red',
    };

    const invertButtonStyle = (color) => ({
        border: `2px solid ${color}`,
        color: `${color}`,
        backgroundColor: 'white',
    });

    const handleAcceptClick = () => {
        setAcceptClicked(!acceptClicked);
        setRejectClicked(false); // Disable reject if accept is clicked
    };

    const handleRejectClick = () => {
        setRejectClicked(!rejectClicked);
        setAcceptClicked(false); // Disable accept if reject is clicked
    };

    const handleManageClick = () => {
        setIsManageModalOpen(true); // Open the Manage modal
    };

    const closeManageModal = () => {
        setIsManageModalOpen(false); // Close the Manage modal
    };

    const handleGenerateReportClick = () => {
        setIsGenerateReportModalOpen(true); // Open the Generate Report modal
    };

    const closeGenerateReportModal = () => {
        setIsGenerateReportModalOpen(false); // Close the Generate Report modal
    };

    const textStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '10px',
    };

    return (
        <li style={itemStyle}>
            {/* Title and Tag */}
            <div style={contentWrapperStyle}>
                <div style={contentStyle}>
                    <h5>{name}</h5>
                    <Tag status={status} />
                </div>

                {/* Action Buttons */}
                <div style={actionsStyle}>
                    {status === 'claimed' ? (
                        <>
                            <button className="btn btn-dark" onClick={handleManageClick}>
                                <FaCog /> Manage
                            </button>
                            <button className="btn btn-primary" style={{ marginLeft: '10px' }}>
                                <FaEnvelope /> Message
                            </button>
                            <button className="btn btn-secondary" style={{ marginLeft: '10px' }} onClick={handleGenerateReportClick}>
                                <FaFileAlt />
                            </button>
                        </>
                    ) : (
                        <>
                            <button className="btn btn-secondary">
                                <FaEye /> View Request
                            </button>
                            <button
                                style={{ 
                                    ...(acceptClicked ? invertButtonStyle('green') : {}), 
                                    marginLeft: '10px' 
                                }}
                                className="btn btn-success"
                                onClick={handleAcceptClick}
                            >
                                <FaCheck /> Accept
                            </button>
                            <button
                                style={{
                                    ...(rejectClicked ? invertButtonStyle('red') : {}),
                                    marginLeft: '10px'
                                }}
                                className="btn btn-danger"
                                onClick={handleRejectClick}
                            >
                                <FaTimes /> Reject
                            </button>
                        </>
                    )}
                </div>
            </div>

            {/* Confirmation Window */}
            {acceptClicked && (
                <div style={acceptConfirmStyle}>
                    <p style={textStyle}>Are you sure you want to accept {name}?</p>
                    <div>
                        <button className="btn btn-success" style={{ marginRight: '10px' }}>Yes</button>
                        <button className="btn btn-secondary" onClick={handleAcceptClick}>No</button>
                    </div>
                </div>
            )}
            {rejectClicked && (
                <div style={rejectConfirmStyle}>
                    <p style={textStyle}>Are you sure you want to reject {name}?</p>
                    <div>
                        <button className="btn btn-danger" style={{ marginRight: '10px' }}>Yes</button>
                        <button className="btn btn-secondary" onClick={handleRejectClick}>No</button>
                    </div>
                </div>
            )}

            {/* Manage Modal */}
            {isManageModalOpen && <ManageModal orgName={name} onClose={closeManageModal} />}

            {/* Generate Report Modal */}
            {isGenerateReportModalOpen && <GenerateReportModal onClose={closeGenerateReportModal} />}
        </li>
    );
};

export default OrganizerItem;
